import { QueryClient } from '@tanstack/react-query'

export const PUBLIC_QUERY_NAMESPACE = 'public'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    },
  },
})

function isProtectedQuery(query) {
  return query.queryKey[0] !== PUBLIC_QUERY_NAMESPACE
}

export function purgeProtectedQueryCache() {
  void queryClient.cancelQueries({ predicate: isProtectedQuery })
  queryClient.removeQueries({ predicate: isProtectedQuery })
  queryClient.getMutationCache().clear()
}
